import styled from '@emotion/styled';

import Card from 'components/global/Card';
import Typography from 'components/global/Typography';

import { Breakpoints } from 'utils/const.styles';

export const CreateShipmentContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	overflow-y: auto;
`;

export const CreateShipmentContent = styled(Card)`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	border-bottom-left-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
	border-bottom: none !important;
	padding: 1.5rem;
`;

export const Title = styled(Typography)`
	padding: var(--padding-2);
	overflow: unset;
`;

export const CreateShipmentBottom = styled(Card)`
	padding: var(--padding-5);
	display: flex;
	border-top: none;
	flex-direction: row;
	justify-content: end;
	gap: 1rem;
	border: none;
	border-top: 0;
	gap: var(--margin-2);
	min-height: fit-content;

	border-top-left-radius: 0 !important;
	border-top-right-radius: 0 !important;

	body[dir='rtl'] & {
		justify-content: left;

		.icon {
			transform: scaleX(-1);
		}
	}

	&.removeMargin {
		margin-top: -2rem;
		min-height: max-content;
	}
`;

export const CreateShipmentContentWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;
	margin: 2.5rem 1rem;
	display: block;
`;

export const CustomHeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	color: var(--black);
	width: 100%;
`;
export const PaymentMethodContainer = styled.div`
	display: flex;
	width: 100%;
	column-gap: 1.5rem;
	row-gap: 0.5rem;
	flex-wrap: wrap;
	height: 100%;
	align-items: start;
	padding: 1rem 0;
`;
export const Radio = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
`;

export const PickupLocationWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1rem;
	height: 100%;
	overflow-y: auto;
`;

export const PickupOptionsButtonContainer = styled.div`
	display: grid;
	width: 100%;
	grid-template-columns: repeat(2, 1fr);
	gap: 2rem;
	padding: 2rem 1rem;
	&.shippingCompany {
		grid-template-columns: repeat(3, 1fr);

		@media ${Breakpoints.mobileLandscape} {
			grid-template-columns: repeat(2, 1fr);
		}
		@media ${Breakpoints.mobile} {
			grid-template-columns: 1fr;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		grid-template-columns: 1fr;
	}
`;

export const ProductsButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;

		.button {
			width: 100%;
		}
	}
`;

export const VerificationWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1rem;
	margin-bottom: 1rem;
`;

export const BoxDetails = styled.div`
	display: flex;
	align-items: center;
	gap: 2rem;
`;

export const BoxWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
`;

export const VerticalLine = styled.div`
	border: 1px solid var(--background-3);
	height: 100%;
`;

export const BoxDetailsTitleWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-bottom: 2.5rem;
	padding-right: 1rem;
`;

export const ProductImageWrapper = styled.div`
	width: auto;
`;

export const ProductWrapper = styled.div`
	display: flex;
	flex-direction: row;
`;

export const ProductAutoCompleteWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: auto;
`;

export const BoxRowWrapper = styled.div`
	width: 100%;
	padding-right: 0.5rem;

	.deleteButton {
		@media ${Breakpoints.tablet} {
			margin-bottom: 1rem;
		}
	}
`;

export const Required = styled.span`
	color: var(--red);
`;

export const OrderContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;

	.form-item-warehouse {
		order: 1;
	}
	.form-item-grandTotal {
		order: 2;
	}
	.form-item-totalDue {
		order: 3;
	}

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		.form-item-warehouse {
			order: 3;
		}
		.form-item-grandTotal {
			order: 1;
		}
		.form-item-totalDue {
			order: 2;
		}
	}
`;
